import * as  React from 'react';
import { getResolutionName } from '../../containers/WorkkardDetail/utils';
;
import { fetchTimezoneAbbreviation } from "../../common/util";
import UserImage from '../UserImage/index';

export default class AssociatedWorkkardCell extends React.Component {
    timeOut = null;

    onMouseEnter = (e,id) => {
        const targetRect = e.currentTarget.getBoundingClientRect();
        this.timeOut = setTimeout(() => this.props.onItemClick(targetRect,id),500)
    }

    onMouseLeave = () => {
        clearTimeout(this.timeOut)
    }

    render(){
        const {data,key, extraData} = this.props;
        return(
            <ul key={key} className={`pd__none ${!data.isViewable ? 'disableText':''}`}>
                <li>{data.isViewable ? (<a href={`/getclmdetail?cId=${data.wkId}`} className="orange">{data.wkNumber}</a>) : data.wkNumber }</li>
                <li className={`status ${data.isViewable ? data.wkStatus.toLowerCase() : ''}`}>{getResolutionName(data.wkStatus)}</li>
                {extraData.isShowOrgCell && <li>{data.organizationName}</li>}
                <li>{data.dynamicFields.lossdate_datetime && data.dynamicFields.lossdate_timezone  && (data.dynamicFields.lossdate_datetime + ' ' + fetchTimezoneAbbreviation(data.dynamicFields.lossdate_timezone))}</li>
                <li>{data.dynamicFields && data.dynamicFields.losstype_singlechoicelist}</li>
                <li className="pointer" >
                    <div className="rowFlex alignMiddle ">
                        <div onMouseEnter={(e) => this.onMouseEnter(e, data.sponsorId)} onMouseLeave={this.onMouseLeave} className="userPic userPicIcon">
                            <UserImage profileUrl={data.profileImageUrl} profileName={data.sponsorName}/>
                        </div>
                        <div className="userInfo flexWrap">
                            <a className="black">{data.sponsorName} {!data.isSponsorActive && (<span className="grey"> (Inactive)</span>)}</a>
                        </div>
                    </div>
                </li>
            </ul>
        );
    }
}